/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addScalarDependencies } from './dependenciesAddScalar.generated';
import { isIntegerDependencies } from './dependenciesIsInteger.generated';
import { isNegativeDependencies } from './dependenciesIsNegative.generated';
import { stirlingS2Dependencies } from './dependenciesStirlingS2.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createBellNumbers } from '../../factoriesAny.js';
export var bellNumbersDependencies = {
  addScalarDependencies: addScalarDependencies,
  isIntegerDependencies: isIntegerDependencies,
  isNegativeDependencies: isNegativeDependencies,
  stirlingS2Dependencies: stirlingS2Dependencies,
  typedDependencies: typedDependencies,
  createBellNumbers: createBellNumbers
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesBellNumbers.generated.js
// module id = 1353
// module chunks = 0